<template>
  <el-footer class="govgr-layout-wrapper" style="height: initial;" role="contentinfo">
    <div class="govgr-full-width-container" >
      <div class="gov-text-center-alignment" v-if="showAppInfo" v-html="appInfo"></div>
      <div class="govgr-footer__meta">
      <div class="govgr-footer__meta-item govgr-footer__meta-item--grow">
        <div class="govgr-footer__content gov-text-valign-center">
          <p class="govgr-footer__licence-description">
            <span @click="toggleAppInfo">© Copyright 2020</span>
             - Υλοποίηση από το <a href="https://www.minedu.gov.gr/" target="_blank" rel="noreferrer noopener" class="govgr-link"> Υπουργείο Παιδείας, Θρησκευμάτων και Αθλητισμού</a>
          </p>
        </div>
        <div class="govgr-footer__meta-item">
         <a href="https://e-doatap.doatap.gr">
          <img class="gov-footer-secondary-logo" src="../assets/Logo-eDoatap_Color.png"/>
          </a>
      </div>
      <!-- <div class="govgr-footer__content govgr-footer__licence-description">
         {{ $t('about') }}
      <el-button type="text" @click="toggleComment">
        {{ $t('report') }}
      </el-button>
      <div class="body" v-show="showComment">
        <el-input
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 8 }"
          :placeholder="$t('placeholder')"
          v-model="textarea"
        >
          class="message">
        </el-input>
        <el-button
          class="butt"
          type="primary"
          style="float: right"
          @click="sendComment"
          >{{ $t('submit') }}
        </el-button>
      </div>
        </div> -->
      </div>
    </div>
    </div>
    <div class="govgr-full-width-container">
      <div class="govgr-footer__content">
        <div class="gov-text-center-alignment">
          {{ developmentTeam }}
        </div>
      </div>
    </div>
  </el-footer>
</template>

<script>
import config from '../config.js'

export default {
  name: 'Foot',
  data () {
    return {
      showAppInfo: config.DEBUG,
      developmentTeam: `Ομάδα Ανάπτυξης Λογισμικού του τμήματος Β' Διαλειτουργικότητας, 
          Ψηφιακής Σύγκλισης και Διοικητικής Υποστήριξης της 
          Δ/νσης Ηλεκτρονικής Διακυβέρνησης και Απλούστευσης Διαδικασιών του Υ.ΠΑΙ.Θ.Α.`,
      appInfo: 'Loading...'
    }
  },
  mounted () {
    this.appInfo = `<b>Release (frontend/backend):</b> ${config.FRONTEND_RELEASE} <b>/</b> Loading... <b>URL:</b> ${config.BASE_URL} <b>User type:</b> ${config.USER_TYPE}`
    config.getBackendRelease().then(version => {
      this.appInfo = `<b>Release (frontend/backend):</b> ${config.FRONTEND_RELEASE} <b>/</b> ${version} <b>URL:</b> ${config.BASE_URL} <b>User type:</b> ${config.USER_TYPE}`
    })
  },
  methods: {
    toggleAppInfo (event) {
      if (event.ctrlKey || event.metaKey) {
        this.showAppInfo = !this.showAppInfo
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Foot.vue